<template>
  <div class="ix">
    <header class="ix-bar">
      <div class="ix-bar-inner">
        <button v-show="!homePage" type="button" class="ix-icon-btn" aria-label="Geri" @click="goBack">
          <span class="material-symbols-outlined">arrow_back</span>
        </button>

        <button
          v-show="homePage"
          type="button"
          class="ix-icon-btn"
          aria-label="Kullanıcı bilgileri"
          data-bs-toggle="offcanvas"
          data-bs-target="#userPanel"
          aria-controls="userPanel"
        >
          <span class="material-symbols-outlined">person</span>
        </button>

        <a class="ix-logo" href="#" @click.prevent>
          <img v-if="customLogo" alt="IzOnay" :src="customLogo" />
          <izonay-logo v-else class="ix-logo-svg" aria-label="İzOnay" />
        </a>

        <button type="button" class="ix-icon-btn" aria-label="Ana sayfa" @click="$router.push({ name: 'Dashboard' })">
          <span class="material-symbols-outlined">home</span>
        </button>
      </div>
      <user></user>
    </header>
    <main id="main" role="main" class="d-flex align-items-center">
      <div class="container-fluid">
        <router-view />
      </div>
    </main>
  </div>
</template>
<script>
import User from "../components/User.vue";
import IzonayLogo from "../components/Voya/IzonayLogo.vue";

export default {
  components:{
    User,
    IzonayLogo
  },
  mounted() {
    // Belge kaydırması kilitlenir; kaydırma #main alanında olur (üst çubuğun arkasında içerik görünmez, sayfa çekilip esnetilemez)
    document.documentElement.classList.add("ix-lock");
  },
  beforeDestroy() {
    document.documentElement.classList.remove("ix-lock");
  },
  beforeCreate(){
    if (!this.$root.$data.login) {
      var path = window.location.pathname ? window.location.pathname : null;
      this.$router.push({ path: '/', query: { redirect: path } })
    }
  },
  computed: {
    customLogo() {
      return this.customLogoPath();
    },
    homePage() {
      if(this.$route.path == "/index" || this.$route.path == "/index/") {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    // Müşteriye özel logo tanımlıysa o kullanılır
    customLogoPath() {
      try {
        return window.settings.customization.imgLogo == null ? null : "../img/" + window.settings.customization.imgLogo;
      } catch (e) {
        return null;
      }
    }
  }
};
</script>

<style scoped>
.ix {
  min-height: 100vh;
  background-color: #F8F8F8;
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

.ix-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  padding-top: env(safe-area-inset-top, 0px);
  background-color: #ffffff;
  border-bottom: 1px solid #EFEFEF;
}

.ix-bar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 56px;
  padding: 0 8px;
}

.ix-icon-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #092154;
  font-size: 26px;
}

.ix-icon-btn:active {
  background-color: #F4F6FA;
}

.ix-logo {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ix-logo img {
  height: 28px;
  width: auto;
}

.ix-logo-svg {
  display: block;
  width: 88px;
  height: 28px;
}

/* Kaydırma alanı: üst çubuğun hemen altında başlar, sayfanın geri kalanı sabit kalır */
#main {
  position: fixed;
  top: calc(57px + env(safe-area-inset-top, 0px));
  right: 0;
  bottom: 0;
  left: 0;
  display: block !important;
  padding-top: 12px;
  padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
}
</style>

<style>
/* Giriş yapılmış alanda belge kaydırılamaz ve esnetilemez */
html.ix-lock,
html.ix-lock body {
  height: 100%;
  overflow: hidden;
  overscroll-behavior: none;
}

html.ix-lock body {
  position: fixed;
  width: 100%;
}
</style>
